import * as React from 'react';
import { IActionBaseProps } from '../components/action/Action';
import { ControlFacet } from '../models/controls/ControlFacet';
import { IWithWizardInjectedProps } from '../components/decorators/withWizard';

export type IRenameWizardProps = IWithWizardInjectedProps & {
  onRename: (props: { name: string }) => Promise<void>;
  itemKey: string;
  oldName: string;
  isAvailable: boolean;
  validator?: (name: string) => string | undefined;
  lockedWarningMessage?: string;
  title?: string;
  fileExtensionText?: string;
};

export const renameActionControl = new ControlFacet<{
  itemKey: string;
}, {
    isAvailable: boolean;
    validator?: (name: string) => string | undefined;
    lockedWarningMessage?: string;
    title?: string;
    renameWizard: React.ComponentType<IRenameWizardProps>;
  }>('renameActionControl');

// @ts-ignore
type __unused_declarations = Pick<
  IActionBaseProps,
  never>;
